import React from 'react';
import { Button, Spinner } from 'reactstrap';
import { useMutation } from '@apollo/react-hooks';
import { RESET_USER_PASSWORD } from '../../mutation/mutation';

const ResetPassword = ({ email }) => {
  const [resetPasswordMutation, { loading }] = useMutation(RESET_USER_PASSWORD);

  const resetPassword = async () => {
    // eslint-disable-next-line no-alert
    const confirm = window.confirm(`Are you sure you want to reset the password of user ${email}?`);
    if (!confirm) return;

    try {
      const {
        data: { savResetUserPassword } = {},
      } = await resetPasswordMutation({ variables: { email } });
      // eslint-disable-next-line no-alert
      window.alert(`New password: ${savResetUserPassword}`);
    } catch (err) {
      // Error
    }
  };

  if (!email) {
    return null;
  }

  return (
    <div>
      {loading
        ? (<Spinner color="primary" />)
        : (
          <Button
            type="submit"
            color="primary"
            onClick={resetPassword}
          >
            Reset password
          </Button>
        )}
    </div>
  );
};

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/user-info/reset-password.js